module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img54.2e40603f.jpg";